<app-page-ribbon></app-page-ribbon>
<app-loader
        [isLoading]="isLoading$ | async"
        [message]="loadingMessage$ | async">
</app-loader>
<button
        *ngIf="showInstallButton"
        (click)="installApp()"
        style="
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #1976d2;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 10px 20px;
    font-size: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    z-index: 1000;
  "
>
    📲 Install App
</button>
<router-outlet></router-outlet>

